import { Button } from "@rumbledirect/ui";
import { Popconfirm, Space, TableColumnsType } from "antd";
import { format, parseISO, compareAsc } from "date-fns";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { Link } from "react-router-dom";
import { UseMutationResult } from "@tanstack/react-query";
import { CheckOutlined, EyeOutlined } from "@ant-design/icons";
import { TaskPriority } from "../../components/TaskPriority";

// Factory to build task columns with a provided completeTask mutation
export const buildTaskColumns = (
  completeMutation: UseMutationResult<null, Error, string>,
): TableColumnsType<Task> => [
  {
    title: "Taak",
    dataIndex: "description",
    key: "description",
    render: (text: string, record: Task) => (
      <Link to={`/claims/tasks/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Toegewezen aan",
    dataIndex: "assignee.firstName",
    key: "assignee",
    render: (_: any, record: Task) =>
      record.assignee?.firstName
        ? record.assignee?.firstName + " " + record.assignee?.lastName
        : "-",
  },
  {
    title: "Notitie",
    dataIndex: "note",
    key: "note",
  },
  {
    title: "Prioriteit",
    dataIndex: "priority",
    key: "priority",
    render: (_: any, record: Task) => (
      <TaskPriority priority={record.priority} />
    ),
  },
  {
    title: "Aangemaakt door",
    dataIndex: "reporter.firstName",
    key: "reporter",
    render: (_: any, record: Task) =>
      record.reporter
        ? record.reporter?.firstName + " " + record.reporter?.lastName
        : "-",
  },
  {
    title: "Datum aangemaakt",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_: any, record) =>
      format(parseISO(record.createdAt), "dd-MM-yyyy HH:mm"),
    sorter: (a, b) => compareAsc(parseISO(a.createdAt), parseISO(b.createdAt)),
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record: Task) => {
      const isRowLoading =
        completeMutation.isPending && completeMutation.variables === record.id;

      return (
        <Space>
          {record.isCompleted == false && (
            <Popconfirm
              title="Taak afvinken"
              description="Weet je zeker dat je deze taak wilt afvinken?"
              okText="Ja"
              cancelText="Nee"
              onConfirm={() => completeMutation.mutate(record.id)}
              okButtonProps={{ loading: isRowLoading }}
              disabled={isRowLoading || record.isCompleted}
            >
              <Button
                loading={isRowLoading}
                disabled={record.isCompleted || isRowLoading}
                icon={<CheckOutlined />}
              >
                Afvinken
              </Button>
            </Popconfirm>
          )}
          <Link to={`/claims/tasks/${record.id}`}>
            <Button icon={<EyeOutlined />} variant="light" />
          </Link>
        </Space>
      );
    },
  },
];
